export default "__VITE_ASSET__FE0Ksq8L__"